import styled, { css } from 'styled-components';

interface ContainerProps {
  isDisabled?: boolean;
}

export const Container = styled.div<ContainerProps>`
  padding: 20px;
  position: relative;
  width: 360px;
  transition: transform 0.2s;
  margin: 10px 0 31px;

  ${(props) =>
    props.isDisabled
      ? css`
          cursor: default;
          opacity: 0.4;
        `
      : css`
          &:hover {
            cursor: pointer;
            transform: scale(1.05);
          }
        `}

  @media (max-width: 930px) {
    max-width: 370px;
    padding-left: 10px;
  }

  @media (max-width: 540px) {
    max-width: 380px;
  }

  @media (max-width: 420px) {
    max-width: 340px;
  }

  @media (max-width: 380px) {
    max-width: 300px;
  }

  @media (max-width: 310px) {
    max-width: 250px;
  }
`;

export const Header = styled.header`
  position: absolute;
  display: flex;

  top: -6px;
  left: 12px;

  p {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    font-size: 1.3rem;

    color: ${({ theme }) => theme.text};

    width: 54px;
  }
`;

export const Content = styled.div`
  box-shadow: 2px 2px 6px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  padding: 14px 8px 14px 0;
  width: 320px;
  height: 130px;
  background: ${({ theme }) => theme.backgroundCard};

  display: flex;
  align-items: center;

  > span {
    width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 60px;
    }
  }

  div {
    height: 80%;

    span {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;

      h1 {
        line-height: 36px;
        font-size: 1.75rem;
        font-weight: 600;
        margin: 0;
        color: ${({ theme }) => theme.text};
      }

      h2 {
        line-height: 25px;
        margin: 0;
        font-weight: 500;
        font-size: 1.2rem;
        color: ${({ theme }) => theme.text};

        &:nth-child(2) {
          margin-bottom: 10px;
        }
      }
    }
  }

  @media (max-width: 380px) {
    width: 260px;
    height: 130px;

    > span {
      img {
        height: 60px;
      }
    }

    div {
      min-width: 125px;
    }
  }

  @media (max-width: 310px) {
    width: 230px;
    height: 130px;

    div {
      span {
        h1 {
          font-size: 1.5rem;
        }

        h2 {
          font-size: 1rem;
        }
      }

      div {
        min-width: 125px;
      }
    }
  }
  > span {
    width: 80px;

    img {
      height: 50px;
    }
  }
`;
